/**
 * Client-side mirror of backend utils/delhivery_fields.manifest_location_errors.
 * Lets the order-create form flag a not-manifest-ready pickup/drop location
 * INLINE (as soon as it's selected) instead of only at submit. The backend guard
 * remains authoritative; this is advisory UX.
 */
const digits = (v) => String(v ?? "").replace(/\D/g, "");
// Same rule as backend normalize_phone: strip non-digits, take the last 10, need exactly 10.
const validPhone = (v) => {
  const d = digits(v);
  return (d.length > 10 ? d.slice(-10) : d).length === 10;
};
const validPin = (v) => /^\d{6}$/.test(String(v ?? "").trim());
const filled = (v) => !!String(v ?? "").trim();

export function pickupIssues(loc) {
  if (!loc) return [];
  const out = [];
  if (!filled(loc.facility_name)) out.push("a facility name");
  // billing phone = pickup_contact -> contact_phone (seller phone fallback is backend-only)
  if (!validPhone(loc.pickup_contact || loc.contact_phone)) out.push("a valid 10-digit contact phone");
  if (!filled(loc.address_line)) out.push("an address");
  if (!filled(loc.city)) out.push("a city");
  if (!filled(loc.state)) out.push("a state");
  if (!validPin(loc.pincode)) out.push("a 6-digit pincode");
  return out;
}

export function dropIssues(loc) {
  if (!loc) return [];
  const out = [];
  if (!filled(loc.contact_person_name || loc.company_name)) out.push("a consignee/contact name");
  if (!validPhone(loc.drop_contact)) out.push("a valid 10-digit contact phone");
  if (!filled(loc.address_line)) out.push("an address");
  if (!filled(loc.city)) out.push("a city");
  if (!filled(loc.state)) out.push("a state");
  if (!validPin(loc.pincode)) out.push("a 6-digit pincode");
  return out;
}

/** Format issues into a one-line message, or "" when the location is ready. */
export function issuesMessage(kind, name, issues) {
  if (!issues || !issues.length) return "";
  const where = kind === "pickup" ? "Pickup Locations" : "Drop Locations";
  return `This ${kind} location${name ? ` “${name}”` : ""} needs ${issues.join(", ")} for the Delhivery manifest. Update it under ${where} before creating the order.`;
}
